const AcademicProjects = [
    {
        name: 'Canada Wide Car Parts',
        description: 'Fully operational e-commerce website to sell car parts. Site provided for a client and was made in 3 months',
        technologies: ['Java', 'ReactJS', 'PostgreSQL', 'Docker'],
        organization: '',
        images: ['https://cwcp-images.s3.us-east-2.amazonaws.com/portfolio/cwcp1.png', 'https://cwcp-images.s3.us-east-2.amazonaws.com/portfolio/cwcp2.png' ,'https://cwcp-images.s3.us-east-2.amazonaws.com/portfolio/cwcp3.png', 'https://cwcp-images.s3.us-east-2.amazonaws.com/portfolio/cwcp4.png', 'https://cwcp-images.s3.us-east-2.amazonaws.com/portfolio/cwcp5.png']
    },
    {
        name: 'Champlain PetClinic',
        github: 'https://github.com/cgerard321/champlain_petclinic.git',
        description: 'Web service continuously worked on by different classes over the years. Teams split into 6 with each team working on their own service and deciding their own tasks',
        technologies: ['Java', 'Docker', 'Angular', 'MongoDB'],
        organization: '',
        images: ['https://cwcp-images.s3.us-east-2.amazonaws.com/portfolio/vet.png', 'https://cwcp-images.s3.us-east-2.amazonaws.com/portfolio/vet1.png', 'https://cwcp-images.s3.us-east-2.amazonaws.com/portfolio/vet2.png', 'https://cwcp-images.s3.us-east-2.amazonaws.com/portfolio/vet3.png']
    },
    {
        name: 'Berry Hunter: The Fox\'s Journey',
        github: 'https://github.com/Sprytte/BerryHunter_TheFoxJourney.git',
        description: 'Platformer game made with Unity',
        technologies: ['Unity', 'C#'],
        organization: '',
        images: ['https://cwcp-images.s3.us-east-2.amazonaws.com/portfolio/berry1.png', 'https://cwcp-images.s3.us-east-2.amazonaws.com/portfolio/berry2.png', 'https://cwcp-images.s3.us-east-2.amazonaws.com/portfolio/berry3.png', 'https://cwcp-images.s3.us-east-2.amazonaws.com/portfolio/berry4.png', 'https://cwcp-images.s3.us-east-2.amazonaws.com/portfolio/berry5.png']
    },
    {
        name: 'BookEater',
        description: 'iOS app meant to allow the user to search for books and add them to their list to keep track of the books they\'ve read',
        technologies: ['XCode', "Swift"],
        organization: '',
        images: ['https://cwcp-images.s3.us-east-2.amazonaws.com/portfolio/book1.png', 'https://cwcp-images.s3.us-east-2.amazonaws.com/portfolio/book2.png', 'https://cwcp-images.s3.us-east-2.amazonaws.com/portfolio/book3.png', 'https://cwcp-images.s3.us-east-2.amazonaws.com/portfolio/book4.png', 'https://cwcp-images.s3.us-east-2.amazonaws.com/portfolio/book5.png', 'https://cwcp-images.s3.us-east-2.amazonaws.com/portfolio/book6.png']
    }
]

const PersonalProjects = [
    {
        name: 'Important Dog',
        github: 'https://github.com/Yan2arb4/DiscordBot.git',
        description: 'Discord bot tailored for our discord server which allows various functionalities such as setting reminders, getting the weather, and tracking your sleep',
        technologies: ['JavaScript'],
        organization: '',
        images: ['https://cwcp-images.s3.us-east-2.amazonaws.com/portfolio/itlb_1.png', 'https://cwcp-images.s3.us-east-2.amazonaws.com/portfolio/itlb_2.png', 'https://cwcp-images.s3.us-east-2.amazonaws.com/portfolio/itlb_3.png']
    }
]

export {AcademicProjects, PersonalProjects};